let colors = {
   primary: {
      spock: 'radial-gradient(hsl(189, 59%, 53%), hsl(189, 58%, 57%))',
      scissors: 'radial-gradient(hsl(39, 89%, 49%),hsl(40, 84%, 53%))',
      paper: 'radial-gradient(hsl(230, 89%, 62%), hsl(230, 89%, 65%))',
      rock: 'radial-gradient(hsl(349, 71%, 52%), hsl(349, 70%, 56%))',
      lizard: 'radial-gradient(hsl(261, 73%, 60%), hsl(261, 72%, 63%))',
   },
   neutral: {
      dark: 'hsl(229, 25%, 31%)',
      score: 'hsl(229, 64%, 46%)',
      header_outline: 'hsl(217, 16%, 45%)',
   },
   background: {
      bck: 'radial-gradient(hsl(214, 47%, 23%), hsl(237, 49%, 15%))',
   },
};

export default colors;
